export default "__VITE_ASSET__BLxyUhfy__"